import { changeHotel, getHotelMeta } from 'actions/hotel';
import { getHotelNewsList } from 'actions/news';
import { getActivities } from 'actions/activity';
import { getAttractions } from 'actions/attraction';
import { getLocationData } from 'actions/location';
import { getFacilities } from 'actions/facility';
import { getPopups, getPopupIndex } from 'actions/popup';
import { getBanner } from 'actions/banner';

import { lanMapRoute, changeLng } from 'util/i18n';

import NewsRoute from './News';
import RestaurantRoute from './Restaurant';
import AccommodationRoute from './Accommodation';
import LocationRoute from './Location';
import ActivityRoute from './Activity';
import FacilityRoute from './Facility';
import PrivacyRoute from './Privacy';
import NotFoundRoute from './NotFound';

export default store => ({
	path: ':hotel',
	onEnter: ({ params: { hotel } }, replace) => {
		const {
			hotel: { hotelList },
		} = store.getState();

		if (!hotelList.includes(hotel)) {
			replace('/');
		}
	},
	indexRoute: {
		onEnter: ({ params: { hotel } }, replace) => {
			const {
				global: { lan },
			} = store.getState();

			replace(`/${hotel}/${lanMapRoute(lan)}`);
		},
	},
	childRoutes: [
		{
			path: ':lang',
			onEnter: ({ params: { lang, hotel } }, replace) => {
				const {
					global: { lan, lanList, lanData },
					hotel: { hotel: storedhotel },
				} = store.getState();

				if (!lanList.map(l => lanData[l].value).includes(lang)) {
					replace('/');
					return;
				}

				if (lanMapRoute(lan) !== lang) {
					changeLng(lang);
				}

				if (storedhotel !== hotel) {
					store.dispatch(changeHotel(hotel));
				}
			},
			indexRoute: {
				getComponent: (nextState, cb) =>
					require.ensure(
						[],
						require => {
							const component = require('./Home').default;
							cb(null, component);
						},
						'Hotels',
					),
				onEnter: ({ params: { lang, hotel } }) => {
					store.dispatch(getHotelNewsList(lang, hotel, {}));
					store.dispatch(getAttractions(lang, hotel));
					store.dispatch(getFacilities(lang, hotel));
					store.dispatch(getActivities(lang, hotel));
					store.dispatch(getLocationData(lang, hotel));
					store.dispatch(getAttractions(lang, hotel));
					store.dispatch(getPopups(lang, hotel));
					store.dispatch(getPopupIndex(lang));
					store.dispatch(getBanner(lang, hotel, 'main'));
					store.dispatch(getHotelMeta(lang, hotel, 'index'));
				},
			},
			childRoutes: [
				NewsRoute(store),
				RestaurantRoute(store),
				AccommodationRoute(store),
				LocationRoute(store),
				ActivityRoute(store),
				FacilityRoute(store),
				PrivacyRoute(store),
				NotFoundRoute(store),
			],
		},
	],
});



// WEBPACK FOOTER //
// ./src/routes/Hotel/index.js